
{
  "fr": {
    "baseInputContent": {
      "action": {
        "edit": {
          "label": "Modifier",
          "title": "@:baseInputContent.action.edit.label"
        },
        "delete": {
          "label": "Supprimer",
          "title": "@:baseInputContent.action.delete.label"
        }
      }
    }
  }
}
